<template>
    <div class="topbar-container">
        <div class="line"></div>
        <validation-observer v-slot="{ invalid }">
            <validation-provider rules="required" name="收货人" v-slot="{ errors }">
                <van-field
                    v-model="formData.contact"
                    clearable
                    maxlength="10"
                    placeholder="收货人"
                    class="border-bottom"
                >
                    <zb-warning slot="right-icon" :message="errors[0]" />
                </van-field>
            </validation-provider>
            <validation-provider rules="required|mobile" name="手机号码" v-slot="{ errors }">
                <van-field
                    v-model="formData.telephone"
                    clearable
                    maxlength="11"
                    placeholder="手机号码"
                    class="border-bottom"
                >
                    <zb-warning slot="right-icon" :message="errors[0]" />
                </van-field>
            </validation-provider>
            <validation-provider rules="required" name="所在地区">
                <zbArea vClass="border-bottom" v-model="addressList"></zbArea>
            </validation-provider>
            <validation-provider rules="required" name="详细地址" v-slot="{ errors }">
                <van-field
                    v-model="formData.address"
                    clearable
                    maxlength="50"
                    placeholder="详细地址：如街道、楼牌号、小区、楼栋号"
                    class="border-bottom"
                >
                    <zb-warning slot="right-icon" :message="errors[0]" />
                </van-field>
            </validation-provider>
            <van-switch-cell
                v-model="formData.isDefault"
                title="设为默认地址"
                :active-value="1"
                :inactive-value="0"
            />
            <div class="line"></div>
            <van-button v-if="isEdit" class="btn btn-red tl" @click="onDelClick(formData.id)">
                <span class="fz_30 btn-span">删除收货地址</span>
            </van-button>
            <div class="bh bc footBar">
                <van-button :disabled="invalid" @click="onSaveClick" class="btn btn-goodbuy">
                    <span class="fz_30 btn-span">保存并使用</span>
                </van-button>
            </div>
        </validation-observer>
    </div>
</template>

<script>
import { user } from "@/mixin/user";
import { routeCache } from "@/mixin/cache";
import { addressEdit, addressInfo, addressDel } from "@/api/user";
import zbArea from "@/components/input/Area";
export default {
    mixins: [routeCache, user],
    name: "UserAddressEdit",
    components: { zbArea },
    data() {
        return {
            isEdit: false,
            addressList: [],
            formData: {},
            addressData: []
        };
    },
    methods: {
        userLoginend() {
            const me = this,
                params = me.getCache();
            me.$store.state.topBarTitle = params.isEdit
                ? "编辑收货地址"
                : "添加收货地址";
            me.isEdit = params.isEdit;
            if (params.id) {
                addressInfo(params.id).then(res => {
                    const data = res.data;
                    me.addressList = [
                        { name: data.province },
                        { name: data.city },
                        { name: data.town }
                    ];
                    me.formData = data;
                });
            }
        },
        onSaveClick() {
            const me = this,
                list = me.addressList;
            me.formData.province = list[0].name;
            me.formData.city = list[1].name;
            me.formData.town = list[2].name;
            addressEdit(me.formData).then(res => {
                this.back();
            });
        },
        onDelClick(id) {
            this.dialog
                .confirm({
                    title: "提示",
                    message: "确定删除？"
                })
                .then(() => {
                    addressDel(id).then(res => {
                        this.back();
                    });
                });
        },
        back() {
            // 更新列表
            this.$store.dispatch("cart/addressList", true);
            this.$router.go(-1);
        }
    }
};
</script>

<style scoped lang="scss">
/deep/ .van-cell {
    padding: 30px;
}
.topbar-container,
.line {
    background: #f1f2f3;
}
.btn-goodbuy {
    width: 510px;
}
.btn-red {
    width: 100%;
}
.footBar {
    padding-top: 100px;
}
/deep/.border-bottom {
    &:after {
        width: calc(100% - 60px);
        border-color: #dcdcdc !important;
        transform: scaleY(1);
    }
}
</style>

